<p-table
  [value]="data"
  [paginator]="true"
  [rows]="itemsPerPage"
  [totalRecords]="totalCount"
  [first]="(currentPage - 1) * itemsPerPage"
  (onPage)="onPageChange($event)"
  [responsiveLayout]="'scroll'"
  [styleClass]="'p-datatable-sm p-datatable-gridlines'">
  <ng-template pTemplate="header">
    <tr>
      @for (column of columns; track column.id) {
      <th (click)="onSort(column.id)">
        {{ column.name | translate }} @if (column.id === sortBy) {
        <i
          class="bi"
          [ngClass]="descSort ? 'bi-arrow-down' : 'bi-arrow-up'"></i>
        }
      </th>
      } @if (actions.length) {
      <th>{{ 'Actions' | translate }}</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      @for (column of columns; track column.id) {
      <td
        (click)="onRowClick(row)"
        pTooltip="{{ resolvePath(row, column.id) }}"
        tooltipPosition="bottom">
        <span class="cursor-pointer">
          {{ currentLanguage === 'en' ? (resolvePath(row, column.id)) :
          (resolvePath(row, column.id + 'Ar') || resolvePath(row, column.id)) }}
        </span>
      </td>
      } @if (actions.length) {
      <td>
        <app-actions-menu
          [actions]="actions"
          [row]="row"
          (openAction)="onAction(row)"></app-actions-menu>
      </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + 1">
        <div class="empty-state-wrapper">
          <i class="bi bi-search"></i>
          <p class="mt-2">{{ 'No-Results-Found' | translate }}</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
